export default __webpack_public_path__ + "static/media/logo.55c0072b.svg";